import getMutation from './get-mutation/'
import getVariables from './get-variables/'
import { reactive, computed } from '@vue/composition-api'
import { getClient } from '..'
import get from '../get/'

export default async ({ root, id, _set, fields, realtime, ids }) => {
  const client = getClient()
  const mutation = getMutation({ root, fields })
  const variables = getVariables({ id: ids || id, _set })

  const payload = await client.mutate({
    mutation,
    variables
  }).catch(error => {
    console.error('error update', error.message)
  })
  const data = payload.data[`update_${root}_by_pk`]
  const constructRealtimeResult = async () => {
    const result = await get({
      root,
      fields,
      request: {
        where: {
          id: {
            _eq: data.id
          }
        }
      },
      realtime
    })
    return reactive(
      Object.fromEntries(Object.keys(result.value[0]).map(key => [
        key,
        computed(() => result.value[0] && result.value[0][key])
      ]))
    )
  }

  return realtime
    ? await constructRealtimeResult()
    : data
}
